import { lazyPage } from '@/lib/lazy-load'

const OrgDetailStoragePage = lazyPage(() => import('./OrgDetailStorage'))
export default OrgDetailStoragePage
